export const isMalvonCateringLanding = () => {
    const { location } = window;
    const { href } = location;
    return href.includes('malvon.es/catering') || href.includes('malvon.es/menucatering');
};
